module.exports = __webpack_public_path__ + "static/media/icita2024.009a4727.png";